module.exports = __webpack_public_path__ + "img/error404.73e88339.gif";